module.exports = __webpack_public_path__ + "img/avatar6.79e723a4.jpg";